/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('DinghyPresenceController', DinghyPresenceController);

    DinghyPresenceController.$inject = ['currentProfile', '$state', '$scope','$sce', 'DinghyBoard', 'ParseLinks', 'AlertService', 'pagingParams', '$http', 'DateUtils', 'Principal'];

    function DinghyPresenceController(currentProfile, $state, $scope, $sce, DinghyBoard, ParseLinks, AlertService, pagingParams, $http, DateUtils, Principal) {
        var vm = this;

        vm.isBoard = false;
        Principal.hasAuthority('ROLE_BOARD').then(function (result) {
            vm.isBoard = result;
        });

        vm.fromDate = pagingParams.fromDate;
        vm.untilDate = pagingParams.untilDate;
        vm.year = new Date().getFullYear();

        vm.currentProfile = currentProfile;

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.fromDate = false;
        vm.datePickerOpenStatus.untilDate = false;
        vm.openCalendar = openCalendar;
        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        vm.transition = transition;
        vm.selectDateRange = selectDateRange;
        vm.updateDateSelection = updateDateSelection;
        vm.selectFromDate = selectFromDate;
        vm.loadAll = loadAll;
        vm.reverseOrder = reverseOrder;

        if (vm.fromDate == null && vm.untilDate == null) {
            // default case --> show passed
            vm.fromDate = getNewYear();
            vm.untilDate = getToday();
            vm.reversed = true;
        } else {
            if (vm.fromDate == null) {
                vm.fromDate = getToday();
            } else {
                vm.fromDate = DateUtils.convertLocalDateFromServer(vm.fromDate);
            }
            if (vm.untilDate == null) {
                vm.untilDate = getToday();
            } else {
                vm.untilDate = DateUtils.convertLocalDateFromServer(vm.untilDate);
            }
            var fromDate = angular.copy(vm.fromDate);
            fromDate.setHours(0, 0, 0, 0);
            var untilDate = angular.copy(vm.untilDate);
            untilDate.setHours(0, 0, 0, 0);
            untilDate.setDate(untilDate.getDate() + 1);
            var midDate = new Date((fromDate.getTime() + untilDate.getTime()) / 2);
            var now = new Date();
            vm.reversed = now.getTime() > midDate.getTime();
        }
        updateDateSelection();

        vm.dinghyEvents = [];
        loadAll();

        function loadAll () {
            $http.get('api/board/dinghy-events/presence', {
                params: {
                    fromDate: DateUtils.convertLocalDateToServer(vm.fromDate),
                    untilDate: DateUtils.convertLocalDateToServer(vm.untilDate)
                }
            }).then(function(response) {
                vm.dinghyEvents = response.data;
                if (vm.reversed) {
                    vm.dinghyEvents.reverse();
                }

            });
        }

        function selectFromDate() {
            $scope.options = {
                minDate: new Date(vm.fromDate),
            };
        }

        function updateDateSelection() {
            if (vm.fromDate == null || vm.untilDate == null) {
                vm.dateSelection = 'custom';
                return;
            }
            vm.selectFromDate();
            var today = getToday();
            var newYear = getNewYear();
            var silvester = getSilvester();

            if (newYear.getTime() === vm.fromDate.getTime()
            && silvester.getTime() === vm.untilDate.getTime()) {
                vm.dateSelection = 'year';
                return;
            }
            if (newYear.getTime() === vm.fromDate.getTime()
                && today.getTime() === vm.untilDate.getTime()) {
                vm.dateSelection = 'passed';
                return;
            }
            if (today.getTime() === vm.fromDate.getTime()
                && silvester.getTime() === vm.untilDate.getTime()) {
                vm.dateSelection = 'future';
                return;
            }
            vm.dateSelection = 'custom';
        }

        function transition() {
            if (vm.fromDate == null || vm.untilDate == null) {
                return;
            }
            var newUntilDate = getDateForServer(getUntilDate());
            var newFromDate = getFromDate();
            if (newUntilDate == null && newFromDate.getTime() === getNewYear().getTime()) {
                newFromDate = null;
            } else if (newFromDate.getTime() === getToday().getTime() && newUntilDate === null) {
                newFromDate = DateUtils.convertLocalDateToServer(newFromDate)
            } else {
                newFromDate = getDateForServer(newFromDate);
            }

            // currently does not reload :/
            $state.transitionTo($state.$current, {
                fromDate: newFromDate,
                untilDate: newUntilDate
            }, {reload: true});
        }

        function getDateForServer(date) {
            if (date.getTime() === getToday().getTime()) {
                return null;
            }
            return DateUtils.convertLocalDateToServer(date);
        }

        function getFromDate() {
            switch (vm.dateSelection) {
                case 'year':
                case 'passed':
                    return getNewYear();
                case 'future':
                    return getToday();
            }
            return vm.fromDate;
        }

        function getUntilDate() {
            switch (vm.dateSelection) {
                case 'year':
                case 'future':
                    return getSilvester();
                case 'passed':
                    return getToday();
            }
            return vm.untilDate;
        }

        function getToday() {
            var today = new Date();
            today.setHours(0, 0, 0, 0);
            return today;
        }

        function getNewYear() {
            var newYear = getToday();
            // Range 0-11 and 1-31
            newYear.setMonth(0, 1);
            return newYear;
        }

        function getSilvester() {
            var silvester = getToday();
            // Range 0-11 and 1-31
            silvester.setMonth(11, 31);
            return silvester;
        }

        function selectDateRange(namedRange) {
            if (namedRange === vm.dateSelection) {
                return;
            }
            var validOptions = ['year', 'future', 'passed'];
            if (validOptions.includes(namedRange)) {
                vm.dateSelection = namedRange;
                vm.fromDate = getFromDate();
                vm.untilDate = getUntilDate();
                vm.transition();
            }
        }

        function reverseOrder() {
            vm.reversed = !vm.reversed;
            vm.dinghyEvents = vm.dinghyEvents.reverse();
        }

        var trusted = {};
        $scope.getPopoverContent = function(content) {
            return trusted[content] || (trusted[content] = $sce.trustAsHtml(content));
        }
    }
})();
